/**
 * @generated SignedSource<<7a7f6adaff3c57ccda02e125dbad3026>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AddWhatToSeeBlockDialog_whatToSee$data = {
  readonly id: string;
  readonly " $fragmentType": "AddWhatToSeeBlockDialog_whatToSee";
};
export type AddWhatToSeeBlockDialog_whatToSee$key = {
  readonly " $data"?: AddWhatToSeeBlockDialog_whatToSee$data;
  readonly " $fragmentSpreads": FragmentRefs<"AddWhatToSeeBlockDialog_whatToSee">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AddWhatToSeeBlockDialog_whatToSee",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "WhatToSee",
  "abstractKey": null
};

(node as any).hash = "820910b242813d9de150c8cae319f626";

export default node;
